/**
 * --------------
 * mpro namespace
 * --------------
 */

// Import mpro modules
import './modules/mpro.dialog.js'; // <-- must be the first included here, to be able to override other handlers
import './modules/mpro.action-handlers.js';
import './modules/mpro.icon.js';
import './modules/mpro.langvar.js';
import './modules/mpro.util.js';
// import './modules/mpro.eval.js';
import './modules/mpro.env.js';
import './modules/mpro.loader.js';
import './modules/mpro.cookies.js';
import './modules/mpro.sections.js';
import './modules/mpro.forms.js';
// import './modules/mpro.project-overrides.js';
import './modules/mpro.string-util.js';
import './modules/mpro.ui.js';
import './modules/mpro.tracking.js';
import './modules/mpro.js-autofill.js';

// TODO: add mpro overlays after implementing priority

// import './modules/mpro.notifications.js';
import './modules/mpro.tooltip.js';
import './modules/mpro.popover.js';
// import './modules/mpro.filters.js';
// import './modules/mpro.plugins.js';

// Import dynamic modules (lazy loaded modules)
import './modules/mpro.dynamic.js';

// Import the mpro initializer
import './ready.js';

// Export mpro namespace
export default mpro;
